import { render, staticRenderFns } from "./ENotas.vue?vue&type=template&id=936a8e86&scoped=true&"
import script from "./ENotas.vue?vue&type=script&lang=js&"
export * from "./ENotas.vue?vue&type=script&lang=js&"
import style0 from "./ENotas.vue?vue&type=style&index=0&id=936a8e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936a8e86",
  null
  
)

export default component.exports